import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth-guard.service';
import { HomeModule } from './home/home.module';
import { SponsorsModule } from './sponsors/sponsors.module';
import { RegPageModule } from './auth/reg-page/reg-page.module';
import { SocialRegisterModule } from './auth/social-register/social-register.module';
import { ForgotPasswordModule } from './auth/forgot-password/forgot-password.module';
import { ValuationsModule } from './valuations/valuations.module';
import { Page404Component } from './page404/page404.component';
import { ViewSponsorshipApplicationsModule } from './sponsors/view-sponsorship-applications/view-sponsorship-applications.module';
import { PropertyOwnerModule } from './property-owner/property-owner.module';
import { PrivateSpaceModule } from './private-space/private-space.module';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full', data: { state: 'home' } },
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => HomeModule)},  
  { path: 'reg-page',loadChildren: () => import('./auth/reg-page/reg-page.module').then(m => RegPageModule), canActivate: [AuthGuard] },
  { path: 'sponsors', loadChildren: () => import('./sponsors/sponsors.module').then(m => SponsorsModule) },
  { path: 'social-register', loadChildren: () => import('./auth/social-register/social-register.module').then(m => SocialRegisterModule)}, 
  { path: 'forgot-password', loadChildren: () => import('./auth/forgot-password/forgot-password.module').then(m => ForgotPasswordModule)},
  { path: 'valuations', loadChildren: () => import('./valuations/valuations.module').then(m => ValuationsModule), canActivate: [AuthGuard]},
  { path: 'view-sponsorship-applications', loadChildren: () => import ('./sponsors/view-sponsorship-applications/view-sponsorship-applications.module').then(m => ViewSponsorshipApplicationsModule)}, 
  { path: 'property-owner-applications', loadChildren: () => import ('./property-owner/property-owner.module').then(m => PropertyOwnerModule)},
  { path: 'private-space', loadChildren: () => import ('./private-space/private-space.module').then(m => PrivateSpaceModule)},  
  { path: '**', pathMatch: 'full', component: Page404Component },
]; 

@NgModule({
  declarations: [
  ],

  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
